/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import $ from 'jquery';

import { PageBreakWidget } from '../SurveyCustomWidgets/PageBreakWidget';
import { EbSlider } from '../SurveyCustomWidgets/EbSlider';
import { EbSliderPolarity } from '../SurveyCustomWidgets/EbSliderPolarity';
import { EbVerticalPolarity } from '../SurveyCustomWidgets/EbVerticalPolarity';
import { EbRating } from '../SurveyCustomWidgets/EbRating';
import { EbStyledRating } from '../SurveyCustomWidgets/EbStyledRating';
import { EbEmoticons } from '../SurveyCustomWidgets/EbEmoticons';
import { EbRadioGroup } from '../SurveyCustomWidgets/EbRadioGroup';
import { EbContactForm } from '../SurveyCustomWidgets/EbContatcForm';
import { EbEmoticons2 } from '../SurveyCustomWidgets/EbEmoticons2';
import { EbDragDrop } from '../SurveyCustomWidgets/EbDragDrop';
import { EbEmoticons3 } from '../SurveyCustomWidgets/EbEmoticons3';

export const SurveyCreatorConfig: any = (
  SurveyKo: any,
  SurveyJSCreator: any,
  widgets: any,
): void => {
  widgets.prettycheckbox(SurveyKo);
  widgets.select2(SurveyKo, $);
  widgets.inputmask(SurveyKo);
  widgets.sortablejs(SurveyKo);
  widgets.ckeditor(SurveyKo);
  widgets.autocomplete(SurveyKo, $);
  widgets.bootstrapslider(SurveyKo);

  SurveyJSCreator.StylesManager.applyTheme('default');

  SurveyJSCreator.removeAdorners([
    'choices-label',
    'rating-item',
    'select-choices',
    'choices-draggable',
  ]);

  SurveyJSCreator.QuestionConverter.convertInfo = {
    checkbox: ['ranking', 'ebdragndrop'],
    ranking: ['checkbox', 'ebdragndrop'],
    ebdragndrop: ['checkbox', 'ranking'],
    text: ['comment'],
    comment: ['text'],
    barrating: [
      'radiogroup',
      'dropdown',
      'ebemotionsratings',
      'funnyemotionsratings',
      'dortmunderemotionsratings',
      'rating',
      'ebslider',
      'ebsliderpolarity',
      'ebverticalpolarity',
    ],
    radiogroup: [
      'dropdown',
      'ebemotionsratings',
      'funnyemotionsratings',
      'dortmunderemotionsratings',
      'barrating',
      'rating',
      'ebslider',
      'ebsliderpolarity',
      'ebverticalpolarity',
    ],
    dropdown: [
      'radiogroup',
      'barrating',
      'ebemotionsratings',
      'funnyemotionsratings',
      'dortmunderemotionsratings',
      'rating',
      'ebslider',
      'ebsliderpolarity',
    ],
    ebemotionsratings: [
      'radiogroup',
      'barrating',
      'dropdown',
      'rating',
      'ebslider',
      'ebsliderpolarity',
      'ebverticalpolarity',
      'funnyemotionsratings',
      'dortmunderemotionsratings',
    ],
    funnyemotionsratings: [
      'radiogroup',
      'barrating',
      'dropdown',
      'ebemotionsratings',
      'dortmunderemotionsratings',
      'rating',
      'ebslider',
      'ebsliderpolarity',
      'ebverticalpolarity',
    ],
    dortmunderemotionsratings: [
      'radiogroup',
      'barrating',
      'dropdown',
      'ebemotionsratings',
      'funnyemotionsratings',
      'rating',
      'ebslider',
      'ebsliderpolarity',
      'ebverticalpolarity',
    ],
    rating: [
      'radiogroup',
      'barrating',
      'dropdown',
      'ebemotionsratings',
      'ebslider',
      'ebsliderpolarity',
      'ebverticalpolarity',
      'funnyemotionsratings',
      'dortmunderemotionsratings',
    ],
    ebslider: [
      'radiogroup',
      'barrating',
      'dropdown',
      'ebemotionsratings',
      'rating',
      'funnyemotionsratings',
      'dortmunderemotionsratings',
      'ebsliderpolarity',
      'ebverticalpolarity',
    ],
    ebsliderpolarity: [
      'radiogroup',
      'barrating',
      'dropdown',
      'ebemotionsratings',
      'rating',
      'funnyemotionsratings',
      'dortmunderemotionsratings',
      'ebslider',
      'ebverticalpolarity',
    ],
    ebverticalpolarity: [
      'radiogroup',
      'barrating',
      'dropdown',
      'ebemotionsratings',
      'rating',
      'funnyemotionsratings',
      'dortmunderemotionsratings',
      'ebslider',
      'ebsliderpolarity',
    ],
  };

  SurveyKo.Serializer.addProperty('survey', {
    name: 'idSurvey:number',
    default: 0,
    category: 'general',
  });

  SurveyKo.Serializer.addProperty('survey', {
    name: 'isTemplate:boolean',
    default: false,
    category: 'general',
  });

  SurveyKo.Serializer.addProperty('survey', {
    name: 'name:string',
    default: false,
    category: 'general',
  });

  SurveyKo.Serializer.addProperty('survey', {
    name: 'isEmbeddedUrl:boolean',
    displayName: 'Use embedded URL',
    default: false,
    serialize: true,
    category: 'general',
    onSetValue(obj: any, value: any) {
      obj.setPropertyValue('isEmbeddedUrl', value);
    },
  });

  SurveyKo.Serializer.addProperty('survey', {
    name: 'embeddedUrl:string',
    displayName: 'Embedded URL',
    default: '',
    serialize: true,
    dependsOn: ['isEmbeddedUrl'],
    visibleIf(obj: { isEmbeddedUrl: boolean }) {
      if (obj.isEmbeddedUrl) {
        return true;
      }
      return false;
    },
    category: 'general',
    onSetValue(obj: any, value: any) {
      obj.setPropertyValue('embeddedUrl', value);
    },
  });

  SurveyKo.Serializer.addProperty('question', {
    name: 'countInProgress:switch',
    default: false,
    category: 'general',
    visibleIf(obj: { internalType: string | number; matrixId: number }) {
      if (obj.matrixId > 0) {
        return true;
      }
      if (obj.internalType === 0) {
        return false;
      }
      return true;
    },
    visibleIndex: 6,
  });

  SurveyKo.Serializer.addProperty('question', {
    name: 'questionId:string',
    default: 0,
    category: 'general',
  });

  SurveyKo.Serializer.addProperty('question', {
    name: 'externalId:number',
    default: 0,
    category: 'general',
  });

  SurveyKo.Serializer.addProperty('question', {
    name: 'matrixId:number',
    default: 0,
    category: 'general',
  });

  SurveyKo.Serializer.addProperty('question', {
    name: 'internalType:string',
    default: 0,
    category: 'general',
  });

  SurveyKo.Serializer.addProperty('question', {
    name: 'questionType:string',
    default: 0,
    category: 'general',
  });

  SurveyKo.Serializer.addProperty('matrix', {
    name: 'splitMatrix:switch',
    displayName: 'Split Matrix',
    category: 'general',
    onSetValue(obj: any, value: any) {
      obj.setPropertyValue('splitMatrix', value);
      obj.setPropertyValue(
        'totalOfRows',
        `Total of Rows in this matrix: ${obj?.rows?.length}`,
      );
    },
  });

  SurveyKo.Serializer.addProperty('matrix', {
    name: 'totalOfRows:string',
    displayName: 'Total of Rows',
    dependsOn: ['splitMatrix'],
    readOnly: true,
    category: 'general',
    visibleIf(obj: { splitMatrix: boolean }) {
      if (obj.splitMatrix) {
        return true;
      }
      return false;
    },
  });

  SurveyKo.Serializer.addProperty('matrix', {
    name: 'numberOfRowsToSplit:number',
    displayName: 'Split matrix after (number of rows):',
    default: () => {
      return 10;
    },
    maxValue: 10,
    minValue: 2,
    category: 'general',
    dependsOn: ['splitMatrix'],
    visibleIf(obj: { splitMatrix: boolean }) {
      if (obj.splitMatrix) {
        return true;
      }
      return false;
    },
    onSetValue(obj: any, value: any) {
      let valueToSet = 1;
      obj.setPropertyValue('numberOfRowsToSplit', value);

      valueToSet = value !== 0 ? Math.ceil(obj.rows.length / value) : 0;

      obj.setPropertyValue('numberOfGroups', valueToSet);

      if (valueToSet - 1 < obj.numberOfGroupsToInsertPageBreakAfter) {
        obj.setPropertyValue(
          'numberOfGroupsToInsertPageBreakAfter',
          valueToSet - 1,
        );
      }
    },
  });

  SurveyKo.Serializer.addProperty('matrix', {
    name: 'numberOfGroups:number',
    displayName: 'Number of row groups that will be generated:',
    default: 10,
    maxValue: 10,
    minValue: 2,
    readOnly: true,
    category: 'general',
    dependsOn: ['numberOfRowsToSplit', 'splitMatrix'],
    visibleIf(obj: { splitMatrix: boolean }) {
      if (obj.splitMatrix) {
        return true;
      }
      return false;
    },
  });

  SurveyKo.Serializer.addProperty('matrix', {
    name: 'numberOfGroupsToInsertPageBreakAfter:number',
    displayName: `Insert the number of groups (splitted) to insert a page break after. Value "0": no page breaks.`,
    default: 0,
    maxValue: 100,
    minValue: 0,
    category: 'general',
    dependsOn: ['splitMatrix', 'numberOfGroups'],
    visibleIf(obj: { splitMatrix: boolean }) {
      if (obj.splitMatrix) {
        return true;
      }
      return false;
    },
    onSetValue(obj: any, value: any) {
      if (obj.numberOfGroups - 1 < value) {
        obj.setPropertyValue(
          'numberOfGroupsToInsertPageBreakAfter',
          obj.numberOfGroups - 1,
        );
      } else {
        obj.setPropertyValue('numberOfGroupsToInsertPageBreakAfter', value);
      }
    },
  });

  SurveyKo.JsonObject.metaData.addProperties('ebcontactform', [
    { name: 'hideNumber', default: true },
  ]);

  SurveyKo.Serializer.addProperty('question', {
    name: 'orderChoices:dropdown',
    category: 'general',
    choices: ['asc value', 'desc value'],
  });

  SurveyKo.CustomWidgetCollection.Instance.add(
    PageBreakWidget(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbSlider(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbSliderPolarity(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbVerticalPolarity(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbStyledRating(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbEmoticons(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbEmoticons2(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbEmoticons3(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbRadioGroup(SurveyKo),
    'radiogroup',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbContactForm(SurveyKo),
    'customtype',
  );

  SurveyKo.CustomWidgetCollection.Instance.add(
    EbDragDrop(SurveyKo),
    'customtype',
  );
  SurveyKo.CustomWidgetCollection.Instance.add(EbRating(SurveyKo), 'rating');

  SurveyKo.Serializer.findProperty('survey', 'isTemplate').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'idSurvey').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'locale').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'mode').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'widthMode').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'width').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'pages').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'calculatedValues').visible =
    false;
  SurveyKo.Serializer.findProperty('survey', 'logo').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'logoPosition').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'logoWidth').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'logoHeight').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'logoFit').visible = false;
  SurveyKo.Serializer.findProperty('survey', 'triggers').visible = true;
  SurveyKo.Serializer.findProperty('survey', 'cookieName').visible = false;
  SurveyKo.Serializer.findProperty('question', 'name').readOnly = true;
  SurveyKo.Serializer.findProperty('question', 'questionId').visible = false;
  SurveyKo.Serializer.findProperty('question', 'externalId').visible = false;
  SurveyKo.Serializer.findProperty('question', 'matrixId').visible = false;
  SurveyKo.Serializer.findProperty('question', 'internalType').visible = false;
  SurveyKo.Serializer.findProperty('question', 'questionType').visible = false;
  SurveyKo.Serializer.findProperty('question', 'enableIf').visible = false;
  SurveyKo.Serializer.findProperty('matrix', 'validators').visible = false;

  SurveyKo.Serializer.findProperty('itemvalue', 'value').readOnly = true;
  SurveyKo.Serializer.findProperty('page', [
    { name: 'visible', default: true },
  ]);

  SurveyKo.Serializer.findProperty('page', 'visible').readOnly = true;
  SurveyKo.Serializer.findProperty('page', 'readOnly').readOnly = true;
  SurveyKo.Serializer.findProperty('page', 'readOnly').visible = false;
  SurveyKo.Serializer.findProperty('page', 'visibleIf').visible = false;
  SurveyKo.Serializer.findProperty('page', 'enableIf').visible = false;
  SurveyKo.Serializer.findProperty('page', 'requiredIf').visible = false;
  SurveyKo.Serializer.findProperty('page', 'visibleIf').visible = false;
  SurveyKo.Serializer.findProperty('page', 'questionTitleLocation').visible =
    false;
  SurveyKo.Serializer.findProperty(
    'page',
    'navigationButtonsVisibility',
  ).visible = false;
  SurveyKo.Serializer.findProperty('page', 'questionsOrder').visible = false;

  SurveyKo.Serializer.findProperty('question', [
    { name: 'hideNumber', default: true },
  ]);

  SurveyKo.Serializer.findProperty('ebcontactform', [
    { name: 'hideNumber', default: true },
  ]);

  SurveyKo.JsonObject.metaData.addClass(
    'itemvalues_questionId',
    [
      {
        name: 'questionIdMatrix',
      },
      {
        name: 'rowVisibleIf',
        displayName: 'Row Visible If',
      },
      {
        name: 'externalId',
        visible: false,
      },
      {
        name: 'questionType',
        visible: false,
      },
      {
        name: 'internalType',
        visible: false,
      },
    ],
    undefined,
    'itemvalue',
  );

  const choicesProp = SurveyKo.JsonObject.metaData.findProperty(
    'matrix',
    'rows',
  );

  choicesProp.className = 'itemvalues_questionId';

  SurveyKo.Serializer.addProperty(
    'itemvalues_questionId',
    'rowVisibleIf',
  ).setValue(choicesProp, '', new SurveyKo.JsonObject());

  SurveyKo.Serializer.findProperty(
    'itemvalues_questionId',
    'questionIdMatrix',
  ).readOnly = true;
};
